import { Box, Button, Card, Dialog, DialogContent, FormControl, Grid, IconButton, MenuItem, Select, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import {Controller, useForm} from 'react-hook-form'
import { CrudServices } from '../../MasterService/CrudServices';
import { ExpertMapServices } from './ExpertMapServices';
import useResponsive from '../../../hooks/useResponsive'
import MapView from './MapView';
import Loading from '../../../components/Loader/Loading';
import { Refresh, RestartAlt } from '@mui/icons-material';

const ExpertServiceMap = () => {
  const {isSm} = useResponsive
  const {control,handleSubmit,watch,setValue,formState:{isDirty},reset,getValues} = useForm({
    defaultValues:{
      categoryId: '',
      subcategoryId: '',
      masterServiceId: '',
      childServiceId: ''
    }
  });
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [masterServiceList, setMasterServiceList] = useState([]);
  const [childServiceList, setChildServiceList] = useState([]);
  const [expertList,setExpertList] = useState([]);
  
  const categoryId = watch('categoryId');
  const subcategoryId = watch('subcategoryId');
  const masterServiceId = watch('masterServiceId');
  const childServiceId = watch('childServiceId');
  const [isLoading, setIsLoading] = useState(false);

  const [isLoadingCategory, setIsLoadingCategory] = useState(false);
  const [isLoadingSubCategory, setIsLoadingSubCategory] = useState(false);
  const [isLoadingMasterService, setIsLoadingMasterService] = useState(false);
  const [isLoadingChildService, setIsLoadingChildService] = useState(false);
  const [fetchingExpertData,setFetchingExpertData] = useState(false);

  useEffect(()=>{
    const fetchCategoryList= async()=>{
      try {
        const categoryListResponse = await ExpertMapServices.getCategoryList();
        console.log("category list Response:",categoryListResponse);
        if(categoryListResponse.success===1){
          setCategoryList(categoryListResponse.data);
          setValue('categoryId',categoryListResponse.data[0].id,{
            shouldValidate:true
          });
        }

      } catch (error) {
        
      }
    }
    fetchCategoryList();
  },[]);

  const fetchSubCategoryList= async()=>{
    try {
      const subCategoryListResponse = await ExpertMapServices.getSubCategoryList(categoryId);
      console.log("subCategory list Response:",subCategoryListResponse);
      if(subCategoryListResponse.success===1){
        setSubCategoryList(subCategoryListResponse.data)
      }
    } catch (error) {
      
    }
  }
  
  useEffect(()=>{
    
    if(categoryId){ 
      setValue('subcategoryId','');
      setValue('masterServiceId','');
      setValue('childServiceId','');
      setSubCategoryList([]);
      setMasterServiceList([]);
      setChildServiceList([]);
      fetchSubCategoryList();
      fetchExpertList();
    }else{
      
    }
  },[categoryId])

  const fetchServiceList= async()=>{
    try {
      const serviceListResponse = await ExpertMapServices.getServicesBySubcategory(subcategoryId);
      console.log("service list Response:",serviceListResponse);
      if(serviceListResponse.success===1){
        setMasterServiceList(serviceListResponse.data)
      }
    } catch (error) {
      
    }
  }
  useEffect(()=>{
    if(subcategoryId){
      setValue('masterServiceId','');
      setValue('childServiceId','');
      setMasterServiceList([]);
      setChildServiceList([]);
      fetchServiceList();
    }else{

    }
  },[subcategoryId])
  useEffect(()=>{
    if(masterServiceId){
      setValue('childServiceId','');
      setChildServiceList([]);
      const masterService = masterServiceList.find((item)=>item.masterServiceId===masterServiceId);
      console.log("childServices",masterService.childServices);
      setChildServiceList(masterService.childServices);
    }else{

    }
  },[masterServiceId])

  const fetchExpertList = async ()=>{
    setFetchingExpertData(true);
    // Get current form values
    const formValues = getValues();
    console.log("Current form values:", formValues);
    
    try {
      const response  = await ExpertMapServices.getExpertList({
        categoryId: formValues.categoryId,
        subcategoryId: formValues.subcategoryId,
        masterServiceId: formValues.masterServiceId,
        childServiceId: formValues.childServiceId
      })
      console.log("expert list response",response);
      if (response.success == '1') {
        setExpertList(response.data.experts)
      }
    } catch (error) {
      console.log("error",error)
    }finally{
      setFetchingExpertData(false)
    }
  }

  const handleFilter =async (data)=>{
    console.log("filter data",data);
    fetchExpertList();
  }
  const clearFilters = ()=>{
    setValue('categoryId',categoryList[0].id,{
      shouldValidate:true
    });
    setValue('subcategoryId','');
    setValue('masterServiceId','');
    setValue('childServiceId','');
    setSubCategoryList([]);
    setMasterServiceList([]);
    setChildServiceList([]);
    fetchExpertList();
  }
  const [isFullscreen,setIsFullscreen] = useState(false);
  return (
    <>
    <Box component='form' onSubmit={handleSubmit(handleFilter)} sx={{my:'1%'}}>
    <Card sx={{p:1}}>
      <Grid container sx={{}}>  
        <Grid item xs={12} sm={2}>
          <Typography sx={{fontSize:'0.75rem',fontWeight:600}}>Select Category</Typography>
          <Controller
            control={control}
            name="categoryId"
            render={({field,fieldState:{error}})=>(
              <FormControl size='small' sx={{ minWidth: "100%" }}>
                {/* <InputLabel id="">Select Gender</InputLabel> */}
                  <Select
                      {...field}
                      size='small'
                      error={!!error}
                      sx={{
                        minHeight: '0px',
                        // height: '1.6rem',
                        fontSize: '0.75rem',
                        // fontWeight: '600',
                        textTransform:'capitalize'
                      }}
                  >
                    {categoryList.map((item)=>
                      <MenuItem key={item.id} value={item.id} sx={{fontSize:'0.75rem',textTransform:'capitalize'}}>{item.title}</MenuItem>
                    )}
                    
                  </Select>
              </FormControl>
          )}  
          />
        </Grid>
        <Grid item xs={.25} sx={{display:{xs:'none',sm:'block'}}}/>
        <Grid item xs={12} sm={2}>
          <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:!categoryId?'lightGray':'auto'}}>Select Sub-Category</Typography>
          <Controller
            control={control}
            name="subcategoryId"
            render={({field,fieldState:{error}})=>(
              <FormControl size='small' sx={{ minWidth: "100%" }}>
                {/* <InputLabel id="">Select Gender</InputLabel> */}
                  <Select
                      {...field}
                      disabled={!categoryId}
                      size='small'
                      error={!!error}
                      sx={{
                        minHeight: '0px',
                        // height: '1.6rem',
                        fontSize: '0.75rem',
                        // fontWeight: '600',
                        textTransform:'capitalize'
                      }}
                  >
                    {subCategoryList.map((item)=>
                      <MenuItem key={item.id} value={item.id} sx={{fontSize:'0.75rem',textTransform:'capitalize'}}>{item.title}</MenuItem>
                    )}
                    
                  </Select>
              </FormControl>
          )}  
          />
        </Grid>
        <Grid item xs={.25} sx={{display:{xs:'none',sm:'block'}}}/>
        <Grid item xs={12} sm={2}>
          <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:!subcategoryId?'lightGray':'auto'}}>Select Master- Service</Typography>
          <Controller
            control={control}
            name="masterServiceId"
            render={({field,fieldState:{error}})=>(
              <FormControl size='small' sx={{ minWidth: "100%" }}>
                {/* <InputLabel id="">Select Gender</InputLabel> */}
                  <Select
                      {...field}
                      disabled={!subcategoryId}
                      size='small'
                      error={!!error}
                      sx={{
                        minHeight: '0px',
                        // height: '1.6rem',
                        fontSize: '0.75rem',
                        // fontWeight: '600',
                        textTransform:'capitalize'
                      }}
                  >
                    {masterServiceList.map((item)=>
                      <MenuItem key={item.masterServiceId} value={item.masterServiceId} sx={{fontSize:'0.75rem',textTransform:'capitalize'}}>{item.title}</MenuItem>
                    )}
                    
                  </Select>
              </FormControl>
          )}  
          />
        </Grid>
        <Grid item xs={.25} sx={{display:{xs:'none',sm:'block'}}}/>
        <Grid item xs={12} sm={2}>
          <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:!masterServiceId?'lightGray':'auto'}}>Select Child-Service</Typography>
          <Controller
            control={control}
            name="childServiceId"
            render={({field,fieldState:{error}})=>(
              <FormControl size='small' sx={{ minWidth: "100%" }}>
                {/* <InputLabel id="">Select Gender</InputLabel> */}
                  <Select
                      {...field}
                      disabled={!masterServiceId}
                      size='small'
                      error={!!error}
                      sx={{
                        minHeight: '0px',
                        // height: '1.6rem',
                        fontSize: '0.75rem',
                        // fontWeight: '600',
                        textTransform:'capitalize'
                      }}
                  >
                    {childServiceList.map((item)=>
                      <MenuItem key={item.childServiceId} value={item.childServiceId} sx={{fontSize:'0.75rem',textTransform:'capitalize'}}>{item.title}</MenuItem>
                    )}
                    
                  </Select>
              </FormControl>
          )}  
          />
        </Grid>
        <Grid item xs={.25} sx={{display:{xs:'none',sm:'block'}}}/>
        <Button disabled={!isDirty} size='small' variant='contained' type='submit' sx={{textTransform:'capitalize',height:'fit-content',alignSelf:'flex-end'}}> 
          Fetch Experts
        </Button>
        <IconButton
          size='small'
          color="primary"
          sx={{ marginLeft: "10px", border: "1px solid", color: "#f00", borderRadius: "7px", padding: ".5%",height:'fit-content',alignSelf:'flex-end' }}
          onClick={clearFilters}
        >
          <RestartAlt sx={{fontSize:'.85rem'}}/>
        </IconButton>
      </Grid>
    </Card>
    </Box>
    {fetchingExpertData ? <Loading/> :
      isFullscreen ? 
    <Dialog
      fullScreen
      open={isFullscreen}
      onClose={() => setIsFullscreen(false)}
    >
      <DialogContent sx={{ p: 0 }}>
        <MapView expertData={expertList} isFullscreen={isFullscreen} setIsFullscreen={setIsFullscreen}/>
      </DialogContent>
    </Dialog>
    :
    <MapView expertData={expertList} isFullscreen={isFullscreen} setIsFullscreen={setIsFullscreen}/>
}
    </>
  )
}
export default ExpertServiceMap


// const expertData = [
//   {
//     name: 'Ravi Sharma',
//     category: 'AC Services',
//     subCategory: 'Cooling',
//     masterService: 'AC Installation',
//     childService: 'Split AC Install',
//     services: ['AC Repair', 'Installation'],
//     location: { lat: 28.6139, lng: 77.209 },
//     radius: 3,
//     area: 'Connaught Place, Delhi',
//   },
//   {
//     name: 'Anita Verma',
//     category: 'Beauty',
//     subCategory: 'Women',
//     masterService: 'Facial',
//     childService: 'Fruit Facial',
//     services: ['Facial', 'Waxing'],
//     location: { lat: 28.5355, lng: 77.391 },
//     radius: 2,
//     area: 'Noida Sector 18',
//   },
//   {
//     name: 'Rahul Singh',
//     category: 'Electrician',
//     subCategory: 'Repairs',
//     masterService: 'Wiring',
//     childService: 'Switch Repair',
//     services: ['Wiring', 'Fan Repair'],
//     location: { lat: 28.4595, lng: 77.0266 },
//     radius: 5,
//     area: 'Gurgaon CyberHub',
//   },
// ];
